import { render, staticRenderFns } from "./UN300MGII.vue?vue&type=template&id=7981180d&"
import script from "./UN300MGII.vue?vue&type=script&lang=js&"
export * from "./UN300MGII.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports